export default {
  root: {
    fontSize: 12,
    fontWeight: 500,
  },
  contained: {
    boxShadow:
      '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    fontSize: 12,
  },
  containedSizeLarge: {
    fontSize: 14,
    fontWeight: 500,
  },
  outlinedSizeLarge: {
    fontSize: 14,
    fontWeight: 500,
  },
};
